<template>
  <div class="polls-list">
    <template v-if="loading">
      <div v-for="n in 3" :key="'skel-' + n" class="poll-skeleton">
        <div class="poll-skeleton__line poll-skeleton__title"></div>
        <div class="poll-skeleton__line poll-skeleton__title-short"></div>
        <div class="poll-skeleton__line poll-skeleton__meta"></div>
      </div>
    </template>

    <div v-else-if="fetchError" class="polls-list__state polls-list__state--error">
      {{ fetchError }}
    </div>

    <div v-else-if="polls.length === 0" class="polls-list__state">
      Nu există sondaje active momentan.
    </div>

    <template v-else>
      <PollCard v-for="poll in polls" :key="poll.id" :poll="poll" />

      <div v-if="lastPage > 1" class="pagination">
        <button
          type="button"
          class="pagination__btn"
          :disabled="page === 1"
          @click="goToPage(page - 1)"
        >
          <i class="mdi mdi-chevron-left" aria-hidden="true"></i> Anterior
        </button>

        <span class="pagination__info">Pagina {{ page }} din {{ lastPage }}</span>

        <button
          type="button"
          class="pagination__btn"
          :disabled="page === lastPage"
          @click="goToPage(page + 1)"
        >
          Următor <i class="mdi mdi-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import PollCard from "./PollCard.vue";

export default {
  name: "PollsList",

  components: { PollCard },

  props: {
    sort: {
      type: String,
      required: true,
    },
    categoryId: {
      type: [Number, String, null],
      default: null,
    },
    categoryIds: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
    page: {
      type: Number,
      default: 1,
    },
  },

  emits: ["update:page"],

  data() {
    return {
      polls: [],
      loading: false,
      fetchError: null,
      lastPage: 1,
    };
  },

  computed: {
    fetchKey() {
      return [this.sort, this.categoryId, this.categoryIds.join(","), this.search, this.page].join("|");
    },
  },

  watch: {
    fetchKey() {
      this.fetchPolls();
    },
  },

  mounted() {
    this.fetchPolls();
  },

  methods: {
    buildParams() {
      const params = { sort: this.sort, page: this.page };
      if (this.categoryIds && this.categoryIds.length > 0) {
        params.category_ids = this.categoryIds;
      } else if (this.categoryId) {
        params.category_id = this.categoryId;
      }
      if (this.search) params.search = this.search;
      return params;
    },

    applyPollsResponse(response) {
      this.polls = response.data.data;
      this.lastPage = response.data.last_page;
    },

    async fetchPolls() {
      this.loading = true;
      this.fetchError = null;
      try {
        const response = await window.axios.get("polls", { params: this.buildParams() });
        this.applyPollsResponse(response);
      } catch (error) {
        // If we get 401, the stored token is invalid — clear it and retry anonymously
        if (error?.response?.status === 401) {
          window.localStorage.removeItem("auth_token");
          delete window.axios.defaults.headers.common.Authorization;
          try {
            const response = await window.axios.get("polls", { params: this.buildParams() });
            this.applyPollsResponse(response);
            return;
          } catch {
            // fall through to generic error
          }
        }
        this.polls = [];
        this.fetchError = "Nu s-au putut încărca sondajele. Încercați din nou.";
      } finally {
        this.loading = false;
      }
    },

    goToPage(newPage) {
      this.$emit("update:page", newPage);
    },
  },
};
</script>
